<template lang="pug">
  header.isMobile(ref="myHeader")
    .header__member
      .center-container(style="max-width: 100%;")
        .pull-left
          router-link.btn-on-air(:to="{name: 'onAir'}")
            span 直播中 On Air
          .arrow-wrap
            .arrow ▲
            .arrow ▲
            .arrow ▲
        .pull-right.user(v-if="isLogin && getUser", v-on:click="userDropdown = !userDropdown")
          .user--name {{ getUser.info.nickname }}
          .user--avatar
            img(src="http://linpohua.com/img/about/mypic.png", :src="getUser.info.picture_url")
          .user-dropdown(v-show="userDropdown")
            li: router-link(:to="{name: 'user'}") 察看票券
            li: router-link(:to="{name: 'ticketType'}") BYOC 購票
            li: router-link(:to="{name: 'selectArea'}") 劃位 / 座位圖
            li: a(@click="logout") 登出
        .pull-right.user(v-else)
          .login-btn(@click="goLogin") 登入
    .mobile-menu(v-if="navToggle", :class="{'isPortrait' : isPortrait}")
      li(v-for="(btn, index) in navBtns", @click="goNav(btn, index)", :class="{'actived' : navActiveStatus === index }")
        router-link(:to="{name: btn.link}") {{ btn.name }}
    .header__main(@click="changeNavToggle")
      .nav-btn-mobile-wrap
        img.nav-btn-mobile(src="~assets/nav-btn-mobile.png")
      .logo
        img(src="~assets/nav-logo-mobile.png")
    .fixed-btn-wrap(v-if="$route.meta.mobileBtn")
      router-link.fixed-btn(:to="{name: 'ticketType'}", v-if="isMobile && !isPortrait") BYOC 購票
      router-link.fixed-btn(:to="{name: 'selectArea'}", v-if="isMobile && !isPortrait") 劃位 / 座位圖
      router-link.fixed-btn(:to="{name: 'user'}", v-if="isMobile && !isPortrait") 察看票券
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import logoImage from 'assets/nav-logo.png'

export default {
  name: 'header',
  beforeRouteEnter (to, from, next) {
  },
  props: {
    isMobile: {
      type: Boolean
    },
    isPortrait: {
      type: Boolean
    },
    isLogin: {
      type: Boolean
    },
    navToggle: {
      type: Boolean
    }
  },
  data () {
    return {
      navImages: {
        logo: logoImage
      },
      navBtns: [
        {
          name: '首頁',
          link: 'homepage'
        },
        {
          name: '活動資訊',
          link: 'activity'
        },
        {
          name: 'BYOC相關',
          link: 'about'
        },
        {
          name: 'BYOC英雄榜',
          link: 'hero'
        },
        {
          name: '官方購物',
          link: 'shopping'
        },
        {
          name: '精彩節目',
          link: 'highlights'
        },
        {
          name: '相關QA',
          link: 'QA'
        },
        {
          name: '特別感謝',
          link: 'thanks'
        },
        {
          name: '媒體報導',
          link: 'news'
        }
      ],
      navActiveStatus: 0,
      userDropdown: false
    }
  },
  computed: {
    ...mapGetters(['getUser'])
  },
  methods: {
    changeNavToggle () {
      this.$emit('update:navToggle', !this.navToggle)
    },
    goLogin () {
      const oauthWindow = window.open('https://oauth.4gamers.com.tw/oauth/authorize?client_id=' + process.env.OAUTH.clientId + '&response_type=code&redirect_uri=' + process.env.OAUTH.redirectUri + '&scope=member.profile.read member.hardware.read member.hardware.write member.notification.read member.notification.write member.games.read member.games.write', 'LoginModal', 'width=600,height=800,scrollbars=no', '_blank')
      let timer = setInterval(function () {
        if (oauthWindow.closed) {
          clearInterval(timer)
          window.location.reload()
        }
      }, 500)
      oauthWindow
    },
    logout () {
      this.userLogout()
      this.$emit('update:isLogin', false)
      if (this.$route.meta.requiredAuth === true) {
        this.$router.push({name: 'homepage'})
      }
    },
    goNav (btn, index) {
      this.navActiveStatus = index
      console.log(btn.name, btn.link, index)
    },
    ...mapActions([
      'userLogout'
    ])
  },
  mounted () {
    for (var i = 0; i < this.navBtns.length; i++) {
      if (this.navBtns[i].link === this.$route.name) {
        this.navActiveStatus = i
      }
    }
    // Passing navHeight to App.vue
    this.$emit('update:navHeight', this.$el.clientHeight)
    // sync navHeight to App.vue after window resize
    window.addEventListener('resize', () => {
      this.$emit('update:navHeight', this.$el.clientHeight)
    }, false)
  },
  watch: {
    // 'navActiveStatus': function () {
    //   console.log(this.navBtns[this.navActiveStatus])
    // },
    'this.$el.clientHeight': function () {
      console.log(this.$el.clientHeight)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import '~stylesheets/variables'
@import '~stylesheets/components'
@import '~stylesheets/mixin'

.btn--white
  background-color: #fff
  color: $red

.btn--white-o
  color: #fff
  background-color: $red
  border: 1px solid #fff
  +transition(all, 0.3s, ease)
  &:hover
    @extend .btn--white

.btn-radius
  +border-radius(999px)


header.isMobile
  user-select: none
  position: fixed
  top: 0
  left: 0
  width: 100%
  z-index: 3
  .header__member
    background-color: $red
    color: #fff
    padding: 3px
    position: relative
    @extend %clearfix
    .btn-on-air
      padding: 0px 8px
      font-size: 12px
      cursor: pointer
      float: left
      color: #fffㄏ
      +transition(all, 0.3s, ease)
      margin-right: 3px
      &:hover
        background-color: #fff
        color: $red
      span
        display: block
    .arrow-wrap
      float: left
      .arrow
        float: left
        font-size: 12px
        +transform(rotate(90deg))
        +animation('flash 2s infinite')
        &:nth-child(2)
          animation-delay: 0.5s
        &:nth-child(3)
          animation-delay: 1s
    .user
      position: relative
      padding: 0px 8px
      +transition(all, 0.3s, ease)
      @extend %clearfix
      // &:hover
      //   padding: 20px
      //   +transform(scale(1.5))
      &--name
        float: left
        font-size: 12px
        margin-right: 8px
        cursor: pointer
      &--avatar
        float: left
        height: 20px
        width: 20px
        +border-radius(50%)
        box-shadow: 0 0 3px #000
        overflow: hidden
        cursor: pointer
        img
          width: 100%
      .login-btn
        border: 1px solid #fff
        color: fff
        +border-radius(999px)
        padding: 1px 8px
        cursor: pointer
        +transition(all, 0.3s, ease)
        &:hover
          background-color: #fff
          color: $red
      .user-dropdown
        position: absolute
        opacity: 1
        top: 100%
        right: 0
        width: 160px
        background-color: $black
        border: 2px solid $red
        list-style: none
        z-index: 999
        padding: 2px
        li
          a
            text-align: center
            display: block
            color: $red-light
            padding: 8px 16px
            text-decoration: none
            cursor: pointer
            +transition(all, 0.3s, ease)
            &:hover
              background-color: $red
              color: #fff
  .header__main
    position: relative
    background: linear-gradient(to right, $black 30%, $red 80%)
    border-bottom: 5px solid $red
    @extend %clearfix
    .nav-btn-mobile-wrap
      padding: 16px 20px
      float: left
      .nav-btn-mobile
        display: block
        max-height: 12px
    .logo
      position: absolute
      left: 50%
      top: 50%
      +transform(translateX(-50%) translateY(-50%))
      max-height: 24px
      img
        display: inline-block
        max-height: 24px
        margin-bottom: 5px
    .btn__nav-switch
      position: absolute
      top: calc(100% + 5px)
      left: 50%
      transform: translateX(-50%)
  .mobile-menu
    position: relative
    background-color: rgba($red, 0.3)
    list-style: none
    text-align: center
    &.isPortrait
      display: flex
      flex-wrap: wrap
      align-content: flex-start
      align-content: stretch
      li
        flex: 1
        min-width: 50%
    li
      display: block
      &.actived
        box-shadow: inset 0 0 40px $red
      a
        color: #fff
        cursor: pointer
        text-align: center
        text-decoration: none
        font-weight: bold
        display: block
        padding: 16px 24px
  </style>



// WEBPACK FOOTER //
// vueHeaderMobile.vue?4a11f702